import {extend} from 'flarum/common/extend';
import Post from 'flarum/forum/components/Post';
import CommentPost from 'flarum/forum/components/CommentPost';
import PictureThumbnail from './components/PictureThumbnail';
import PrivatePictureThumbnail from './components/PrivatePictureThumbnail';
import UploadedPost from './components/UploadedPost';
import Picture from './models/Picture';
import PrivatePicture from './models/PrivatePicture';

function extendPost(PostComponent: any) {
    extend(PostComponent.prototype, 'content', function (this: Post, items: any[]) {
        const {post} = this.attrs;

        const pictures = post.cimaisePictures();

        if (!pictures || !pictures.length) {
            return;
        }

        items.push(m('.AlbumPictureList', pictures.map(picture => {
            if (!(picture instanceof Picture)) {
                return m(PrivatePictureThumbnail, {
                    picture,
                });
            }

            // Fill in the missing relationships in case they were not returned by the API
            // This doesn't solve everything because we don't always have the discussion album either
            if (!picture.album()) {
                const album = post.discussion().cimaiseAlbum();

                if (album) {
                    picture.data.relationships = picture.data.relationships || {};
                    picture.data.relationships.album = {
                        data: {
                            type: 'cimaise-albums',
                            id: album.id()!
                        }
                    }
                }
            }

            return m(PictureThumbnail, {
                picture,
                showUser: false,
                showAlbum: false,
                openInLightbox: true,
            });
        })));
    });
}

export default function () {
    extendPost(CommentPost);
    extendPost(UploadedPost);

    extend(Post.prototype, 'oninit', function () {
        const {post} = this.attrs;

        this.subtree!.check(() => JSON.stringify((post.cimaisePictures() || []).map((picture: Picture | PrivatePicture | undefined) => {
            return picture && picture.freshness;
        })))
    });
}
